export default __webpack_public_path__ + "images/2T.5e5dcfa.png";